// In product-desplegable.liquid and product-desplegable-2.liquid 
// we are using not the default arrows, but we changed for  "+" and "-"
//------------------------------------------------------------------------
// when a pangoClick is clicked : 
// if the element clicked was "+": reset all the others to "+" and change this to "-"
// if the element clicked was "-": change it to "+"
const pangoClickElements = document.querySelectorAll('.pangoClick');

function handleClick(event) {
  const selectedPangoPlus = event.currentTarget.querySelector('.pangoPlus');
  const selectedPangoMinus = event.currentTarget.querySelector('.pangoMinus');

  if (selectedPangoMinus.hasAttribute('hidden')) {
    pangoClickElements.forEach(element => {
      let pangoPlus = element.querySelector('.pangoPlus');
      let pangoMinus = element.querySelector('.pangoMinus');
      pangoPlus.hidden = false;
      pangoMinus.hidden = true;
    });
    selectedPangoPlus.hidden = true;
    selectedPangoMinus.hidden = false; 
  } else {
    selectedPangoPlus.hidden = false;
    selectedPangoMinus.hidden = true; 
  }
}

pangoClickElements.forEach(element => {
  element.addEventListener('click', handleClick);
});


//------------------------------------------------------------------------
// when another collapsible not pangoclick is clicked:
// reset all pangoclicks to "+"
function resetAllPangoClicks(){
  pangoClickElements.forEach(element => {
        let pangoPlus = element.querySelector('.pangoPlus');
        let pangoMinus = element.querySelector('.pangoMinus');
        pangoPlus.hidden = false;
        pangoMinus.hidden = true;
  });
}
const collapsible__buttonElements = document.querySelectorAll('.collapsible__button:not(.pangoClick)');
collapsible__buttonElements.forEach(element => {
 element.addEventListener('click', resetAllPangoClicks);
});
